import { Component, OnInit } from '@angular/core';
import "./weather-station.component.scss";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import localeNn from '@angular/common/locales/nn';
import { registerLocaleData } from '@angular/common';
import * as signalR from "@microsoft/signalr";

registerLocaleData(localeNn);

@Component({
  selector: 'weather-station',  
  templateUrl: './weather-station.component.html'
})

export class WeatherStationComponent implements OnInit {
  
  windSample: any;
  hubConnection: signalR.HubConnection;
  connectCount: number = 0;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {

    this.hubConnection = new signalR.HubConnectionBuilder().withUrl('https://iot.rbt.no/Signal').build();
 
    this.hubConnection.on('WindSample', (windSample) => {
        this.windSample = windSample;
        console.log(windSample);
    });

    this.hubConnection.onclose( (error) => {
      console.log("Disconnected from hub: " + error);
      setTimeout( () => this.connectSignal(), this.getConnectSleep());
    });

    this.connectSignal();
      
  }

  connectSignal() {
    this.connectCount++;
    console.log("Connecting hub");
    this.hubConnection
      .start()
      .then(() => {
        console.log("Connected to hub");
        this.connectCount = 0;
        this.hubConnection.invoke('JoinSensor', 1);
        this.http.get("https://iot.rbt.no/wind/GetSample?sensorId=1").subscribe(
          (windSample) => {
              this.windSample = windSample;
          },
          
          () => {
              
        });
      })
      .catch(err => {
        console.log('Error connecting to hub: ' + err);
        setTimeout( () => this.connectSignal(), this.getConnectSleep());
      })
  } 
  
  getConnectSleep() {
    if (this.connectCount < 3)
      return 5000;

    if (this.connectCount < 6)
      return 10000;

      return 20000;
  }
}